import { css } from 'styled-components';

export default css`
  table {
    width: 100%;
  }
`;
